import './App.css';
import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import axios from "axios";

import AdminLogin from "./pages/LoginPage";
import DashboardLayout from "./pages/DashboardLayout";
import UsersPage from "./pages/UsersPage";
import PackagesPage from "./pages/PackagesPage";
import SubscriptionPage from "./pages/SubscriptionPage";
import BotsPage from "./pages/BotsPage";
import SupportPage from "./pages/SupportPage";
import CampaignPage from "./pages/CampaignPage";
import MatPage from "./pages/MatPage";
import FeedbackPage from "./pages/FeedbackPage";
import SettingsPage from "./pages/SettingsPage";
import ProfilePage from "./pages/ProfilePage";
import DashboardHome from "./pages/DashboardHome";
import ProtectedRoute from "./components/ProtectedRoute";
import PaymentsOverview from "./pages/payments/PaymentsOverviewPage";
import PaymentsList from "./pages/payments/PaymentsListPage";
import PaymentError from "./pages/payments/PaymentErrorsPage";

function App() {
  // 🔐 Axios global setup: token + 401 redirect
  useEffect(() => {
    // İstersen baseURL'ü de burada sabitleyebilirsin (UsersPage tam URL kullanıyor ama genel iyi olur)
    // axios.defaults.baseURL = process.env.REACT_APP_BACKEND_URL;

    const setAuthHeader = () => {
      axios.defaults.headers.common["Authorization"] =
        `Bearer ${localStorage.getItem("token") || ""}`;
    };
    setAuthHeader();

    // Login/logout sonrası başka sekmeden değişirse güncelle
    const onStorage = (e) => {
      if (e.key === "token") setAuthHeader();
    };
    window.addEventListener("storage", onStorage);

    // 401 yakala → login'e gönder
    const respId = axios.interceptors.response.use(
      r => r,
      err => {
        if (err?.response?.status === 401) {
          localStorage.removeItem("token");
          window.location.href = "/login";
        }
        return Promise.reject(err);
      }
    );

    return () => {
      window.removeEventListener("storage", onStorage);
      axios.interceptors.response.eject(respId);
    };
  }, []);

  return (
    <Router>
      <Routes>
        <Route path="/" element={<Navigate replace to="/login" />} />
        <Route path="/login" element={<AdminLogin />} />

        <Route path="/dashboard" element={
          <ProtectedRoute>
            <DashboardLayout title="Ana Sayfa"><DashboardHome /></DashboardLayout>
          </ProtectedRoute>
        } />

        <Route path="/users" element={
          <ProtectedRoute>
            <DashboardLayout title="Kullanıcılar"><UsersPage /></DashboardLayout>
          </ProtectedRoute>
        } />

        <Route path="/subscriptions" element={
          <ProtectedRoute>
            <DashboardLayout title="Abonelikler"><SubscriptionPage /></DashboardLayout>
          </ProtectedRoute>
        } />

        <Route path="/packages" element={
          <ProtectedRoute>
            <DashboardLayout title="Paketler"><PackagesPage /></DashboardLayout>
          </ProtectedRoute>
        } />

        <Route path="/campaign" element={
          <ProtectedRoute>
            <DashboardLayout title="Kampanyalar"><CampaignPage /></DashboardLayout>
          </ProtectedRoute>
        } />

        <Route path="/bots" element={
          <ProtectedRoute>
            <DashboardLayout title="Botlar"><BotsPage /></DashboardLayout>
          </ProtectedRoute>
        } />

        <Route path="/educationmat" element={
          <ProtectedRoute>
            <DashboardLayout title="Eğitim İçerikleri"><MatPage /></DashboardLayout>
          </ProtectedRoute>
        } />

        <Route path="/payments/overview" element={
          <ProtectedRoute>
            <DashboardLayout title="Genel Bakış"><PaymentsOverview /></DashboardLayout>
          </ProtectedRoute>
        } />
        <Route path="/payments/users" element={
          <ProtectedRoute>
            <DashboardLayout title="Kullanıcı Ödemeleri"><PaymentsList /></DashboardLayout>
          </ProtectedRoute>
        } />
        <Route path="/payments/errors" element={
          <ProtectedRoute>
            <DashboardLayout title="Ödeme Hataları"><PaymentError /></DashboardLayout>
          </ProtectedRoute>
        } />
        <Route path="/support" element={
          <ProtectedRoute>
            <DashboardLayout title="Destek Talepleri"><SupportPage /></DashboardLayout>
          </ProtectedRoute>
        } />

        <Route path="/feedback" element={
          <ProtectedRoute>
            <DashboardLayout title="Geri Bildirimler"><FeedbackPage /></DashboardLayout>
          </ProtectedRoute>
        } />

        <Route path="/settings" element={
          <ProtectedRoute>
            <DashboardLayout title="Ayarlar"><SettingsPage /></DashboardLayout>
          </ProtectedRoute>
        } />

        <Route path="/profile" element={
          <ProtectedRoute>
            <DashboardLayout title="Profil"><ProfilePage /></DashboardLayout>
          </ProtectedRoute>
        } />
      </Routes>
    </Router>
  );
}

export default App;
